import React from "react";
import me from './images/me-nobg.png';
import Typewriter from "./Typewriter";

const Intro = ({refSection}) => {
    const textArray = ["Frontend", "Backend", "Fullstack"];

    return (
        <div className="Intro phone:p-[40px]" ref={refSection}>
            <img src={me} className="flex justify-center mr-auto ml-auto w-72" alt="Me" />
            <div className="Name flex-row justify-center mr-auto ml-auto align-center items-center justify-center text-center md:text-4xl font-bold text-2xl">
                <div className="flex flex-row md:max-w-[300px] max-w-[200px] mr-auto ml-auto justify-between ">
                    <p className="tracking-widest text-justify">MARK</p>
                    <p className="tracking-widest text-justify">DHEM</p>
                </div>
                <div className="flex flex-row md:max-w-[300px] max-w-[200px] mr-auto ml-auto justify-between">
                    <p className="tracking-widest text-justify">MANS</p>
                    <p className="tracking-widest text-justify">UETO</p>
                </div>
            </div>
            <div className="text-center md:text-2xl mt-4 text-wrap text-base">
                I can be your <Typewriter texts={textArray} typingSpeed={100} eraseSpeed={50} delay={1000} /> Developer
            </div>
        </div>
    );
}

export default Intro;
